import { Tag } from 'antd';
import { ORDER_STATUS_LABEL, type OrderStatus } from '../../api/billing.api';

const statusColor: Record<OrderStatus, string> = {
  PENDING_PAYMENT: 'orange',
  PARTIALLY_PAID: 'blue',
  PAID: 'green',
  CANCELLED: 'default',
  EXPIRED: 'red',
};

/** 订单状态标签。 */
export function OrderStatusTag({ status }: { status: OrderStatus }) {
  return <Tag color={statusColor[status]}>{ORDER_STATUS_LABEL[status]}</Tag>;
}
